import React from "react";
import { Button, Modal, List, Input } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { ReactSVG } from "react-svg";

const { Search } = Input;

const SwapDriver = ({ state, handleOk, handleCancel, handleSelectedRoute, onSeachDrivers }) => {
  return (
    <Modal
      open={state.visibleModal}
      title="Swap Driver"
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          CANCEL
        </Button>,
        <Button key="submit" type="primary" disabled={Object.keys(state.swapToRoute).length === 0} onClick={handleOk}>
          SWAP DRIVER
        </Button>,
      ]}
      width={370}
      className="swap-driver-modal">
      <div className="ListDrivers">
        <Search className="mb-3" placeholder="Search Driver" onChange={e => onSeachDrivers(e)} />
        <List>
          {state.searchedRoutes.map((route, index) => {
            const driver = route.driver;
            return (
              <List.Item key={index}>
                <div className="content">
                  <div className="left">
                    <span role="img" aria-label="support" className="anticon driver">
                      <ReactSVG className={`ReactSVG-${driver.color}`} src={"/icons/drivers.svg"} />
                    </span>
                    <b>{driver.name}</b>
                  </div>
                  <div className="right">
                    <Button type="link" onClick={() => handleSelectedRoute(route)}>
                      {route.driver._id === state.swapToRoute.driver?._id && (
                        <span className="selected">
                          {" "}
                          Selected <CheckOutlined />{" "}
                        </span>
                      )}
                      {route.driver._id !== state.swapToRoute.driver?._id && <span className="select"> Select </span>}
                    </Button>
                  </div>
                </div>
              </List.Item>
            );
          })}
        </List>
      </div>
    </Modal>
  );
};

export default SwapDriver;
